import { setItem } from "../../system/helpers/localstorageHelper";

export const handleStatusType = (state, setState, key) => {
  const statusCondition = state === "public" ? "all" : "public";
  setState(statusCondition);
  setItem(key, statusCondition);
};
